const i18n = {
  'zh-CN': {
    // 工作台
    'menu.dashboard': '工作台',
    'menu.dashboard.workplace': '工作台',
    'menu.dashboard.monitor': '实时监控',
    'menu.dashboard.hrbpAttendance': '出勤工时',
    'menu.dashboard.resources': '资源饱和度',
    // 商业项目管理
    'menu.projects': '商业项目',
    'menu.projects.list': '项目列表',
    'menu.projects.create': '创建项目',
    'menu.projects.detail': '项目详情',
    'menu.projects.change': '项目变更',
    'menu.projects.pendingEntry': '补录申请',
    'menu.projects.frameworks': '框架协议',
    'menu.projects.frameworksCreate': '创建框架协议',
    // 售前支持
    'menu.presales': '售前支持',
    'menu.presales.list': '售前列表',
    // 专业贡献
    'menu.contributions': '专业贡献',
    'menu.contributions.list': '专业贡献列表',
    // 任务和工时管理
    'menu.tasks': '任务工时',
    'menu.tasks.management': '任务管理',
    'menu.tasks.calendar': '工时日历',
    // 待办中心（审批管理）
    'menu.approvals': '待办中心',
    'menu.approvals.list': '审批列表',
    // 业绩管理
    'menu.performance': '业绩管理',
    'menu.performance.list': '业绩列表',
    // 成本管理
    'menu.costs': '成本管理',
    'menu.costs.labor': '人力成本',
    'menu.costs.travel': '差旅成本',
    'menu.costs.outsource': '外包成本',
    // 报表中心
    'menu.reports': '报表中心',
    'menu.reports.completedPerformance': '完成业绩报表',
    'menu.reports.acceptancePerformance': '验收业绩报表',
    'menu.reports.signedPerformance': '签单业绩报表',
    'menu.reports.developmentHours': '工时统计报表',
    'menu.reports.developmentHoursDrilldown': '工时统计报表下钻',
    'menu.reports.report1': '报表1',
    // 系统设置
    'menu.settings': '系统设置',
    'menu.settings.users': '用户管理',
    'menu.settings.systemPermissions': '系统权限',
    'menu.settings.projectPermissions': '项目权限',
    'menu.settings.cost': '人日成本设置',
    'menu.settings.approval': '审批流程设置',
    'menu.settings.other': '其他设置',
    'menu.settings.other.clientDepartments': '客户部设置',
    'menu.settings.other.suppliers': '供应商设置',
    'menu.settings.other.stageTemplates': '阶段与里程碑模板',
    'menu.settings.other.approvalProcessTemplates': '审批流程模板',
    'menu.settings.other.workday': '工作日设置',
    'menu.settings.other.taskTypes': '任务类型设置',
    'menu.settings.other.otherTasksConfig': '其他任务设置',
    'navbar.logout': '退出登录',
    // 消息相关
    'message.tab.title.message': '消息',
    'message.tab.title.notice': '通知',
    'message.tab.title.todo': '待办',
    'message.allRead': '全部已读',
    'message.seeMore': '查看更多',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'navbar.search.placeholder': '输入内容查询',
  },
};

export default i18n;
